import validator from "validator";
import message from "../../../../messages/auth";
import messagesUser from "../../../../messages/user";
import mobileValidator from "../../../mobile";

const validateFirstName = (firstName) => {
  if (validator.isEmpty(firstName)) {
    return message.FIRST_NAME_DOSE_NOT_EXIST;
  }

  if (!firstName.trim().length) {
    return message.FIRST_NAME_DOSE_NOT_EXIST;
  }

  const regexFarsiCharter = /^[\u0600-\u06FF\s]+$/;
  if (!regexFarsiCharter.test(firstName)) {
    return message.FIRST_NAME_DOSE_NOT_FARSI_CHAR;
  }

  return true;
};

const validateMobile = (mobile) => {
  if (validator.isEmpty(mobile)) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobile.trim().length) {
    return message.USER_MOBILE_DOSE_NOT_EXIST;
  }

  if (!mobileValidator.isNumericMobile(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  if (!mobileValidator.validMobileNumber(mobile)) {
    return message.USER_MOBILE_WRONG;
  }

  return true;
};

const validateCatGuild = (catGuild) => {
  if (validator.isEmpty(catGuild)) {
    return messagesUser.CATEGORY_USER_ID_DOSE_NOT_EXIST;
  }

  if (!catGuild.trim().length) {
    return messagesUser.CATEGORY_USER_ID_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(catGuild)) {
    return messagesUser.CATEGORY_USER_ID_IS_WRONG;
  }

  if (catGuild == "0") {
    return messagesUser.CATEGORY_USER_ID_IS_WRONG;
  }

  return true;
};

const validationEdit = (info) => {
  const resValidateFirstName = validateFirstName(info.first_name);
  if (resValidateFirstName != true) {
    return resValidateFirstName;
  }

  const resValidateMobile = validateMobile(info.mobile);
  if (resValidateMobile != true) {
    return resValidateMobile;
  }

  const resValidateCatGuild = validateCatGuild(info.cat_guild);
  if (resValidateCatGuild != true) {
    return resValidateCatGuild;
  }

  return true;
};

export default validationEdit;
